import { Subject } from "rxjs";

const subject = new Subject();

export const categoryLinkService = {
  selectCategory: (cat) => subject.next({ category: cat }),
  clearCategories: () => subject.next(),
  getCategory: () => subject.asObservable(),
};
